export enum AppointmentStatus {
  Waiting = 1,
  Completed = 2,
}
